// Rename to: src/config/user-client-config.js
// This data to be used for the web client user account
// Data should be the same as the data used for the web client user account
export const GHI_WEB_CLIENT_NAME='GHI Web Client'
export const GHI_WEB_CLIENT_PHONE='9999999999'
export const GHI_WEB_CLIENT_EMAIL='ghiwebclient@mystrand.org'
export const GHI_WEB_CLIENT_PASSWORD='d8JMobTUKxGdupe'
